import { Link } from "react-router-dom";
import { LOGO_URL } from "../data/caseStudies";

export default function Navbar() {
  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-40 w-full backdrop-blur-xl bg-black/60 border-b border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex items-center justify-between h-16">
        <Link
          to="/"
          data-testid="navbar-logo-link"
          className="flex items-center gap-3 group"
        >
          <div className="relative w-9 h-9 rounded-lg overflow-hidden border border-white/10 group-hover:border-[#FF1493]/60 transition">
            <img src={LOGO_URL} alt="LinkSync" className="w-full h-full object-cover" />
          </div>
          <span className="font-serif-display text-[20px] tracking-tight">
            LinkSync
          </span>
          <span className="ls-overline hidden md:inline ml-2">
            Agence d'influence
          </span>
        </Link>

        <a
          href="mailto:contact@linksync.fr"
          data-testid="nav-cta"
          className="inline-flex items-center gap-2 h-9 px-4 rounded-full bg-white text-black text-sm font-medium hover:bg-[#FF1493] hover:text-white transition"
        >
          Travaillons ensemble
        </a>
      </div>
    </header>
  );
}
